import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { t } from "../../services/utils";
import { updateAppTitle } from "../../data/app/app-title-slice";
import {
  useGetReferralsQuery,
  useUpdateReferralMutation,
} from "../../data/referral/api";
import OnboardingCard from "../../components/OnboardingCard";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import { primary, primaryDark } from "../../constants/colors";
import { updateChatState } from "../../data/app/actions";
import channelTypes from "../../constants/channel-type";
import { GET_CLIENTS } from "../../constants/action-types";
import moment from "moment";

export default function ReferralView() {
  const dispatch = useDispatch();
  const { data: referrals = [], isLoading } = useGetReferralsQuery();
  const [updateReferral] = useUpdateReferralMutation();

  const openChat = (clientId: number | null) => {
    if (!clientId) return;
    dispatch(updateChatState({
      channelType: channelTypes.CHAT,
      isOpen: true,
      clientId,
    }));
  };

  useEffect(() => {
    dispatch(updateAppTitle(t("referrals")));
    dispatch({ type: GET_CLIENTS.REQUEST });
  }, []);

  if (isLoading) {
    return null;
  }

  if (referrals.length === 0) {
    return (
      <div style={styles.onboardingContainer}>
        <OnboardingCard
          img={require("../../img/onboarding-referral.png")}
          title={t("getMoreClientsThroughReferrals")}
          description={t("referralOnboardingDescription")}
          isLearnMore={true}
          onLearnMoreBtnClick={() => window.open("https://help.trainerfu.com/en/collections/18934848-referral-marketing", "_blank")}
          style={{ marginTop: 60 }}
        />
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <Paper elevation={1} style={styles.paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={styles.headerCell}>{t("source")}</TableCell>
              <TableCell style={styles.headerCell}>{t("client")}</TableCell>
              <TableCell style={styles.headerCell}>
                {t("packageName")}
              </TableCell>
              <TableCell style={styles.headerCell}>
                {t("dateJoined")}
              </TableCell>
              <TableCell style={styles.headerCell}>{t("rewarded")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {referrals.map((referral) => (
              <TableRow key={referral.id}>
                <TableCell>
                  <span
                    style={referral.sponsor_id ? styles.linkCell : undefined}
                    onClick={() => openChat(referral.sponsor_id)}
                  >
                    {[referral.sponsor_first_name, referral.sponsor_last_name]
                      .filter(Boolean)
                      .join(" ")}
                  </span>
                </TableCell>
                <TableCell>
                  <span
                    style={referral.client_id ? styles.linkCell : undefined}
                    onClick={() => openChat(referral.client_id)}
                  >
                    {[referral.client_first_name, referral.client_last_name]
                      .filter(Boolean)
                      .join(" ")}
                  </span>
                </TableCell>
                <TableCell>{referral.package_name}</TableCell>
                <TableCell>
                  {referral.created_at
                    ? moment(referral.created_at).format("Do MMMM YY")
                    : ""}
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={referral.rewarded}
                    onChange={() =>
                      updateReferral({
                        id: referral.id,
                        rewarded: !referral.rewarded,
                      })
                    }
                    color="primary"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: 40,
  },
  onboardingContainer: {
    display: "flex",
    width: 805,
    maxWidth: 805,
    flexDirection: "column",
    marginLeft: "auto",
    marginRight: "auto",
    padding: 40,
  },
  paper: {
    borderRadius: 6,
    overflow: "hidden",
  },
  headerCell: {
    fontWeight: 600,
    color: primaryDark,
    fontSize: 14,
  },
  linkCell: {
    color: primary,
    cursor: "pointer",
  },
};
